<template>
    <div class="message-list">
        <transition-group name="fade">
            <article v-for="message of messages" :key="message.id" class="message"
                     :class="message.type ? `is-${message.type}` : ''">
                <div class="message-header">
                    <p>{{message.title}}</p>
                    <button class="delete" @click="dismiss(message.id)"></button>
                </div>
                <div class="message-body" v-html="message.message"></div>
            </article>
        </transition-group>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {DISMISS_MESSAGE} from "../store";

    export default {
        name: "message-list",
        computed: {
            ...mapState(["messages"])
        },
        methods: {
            dismiss(id) {
                this.$store.commit(DISMISS_MESSAGE, id);
            }
        }
    }
</script>

<style lang="scss">
    @import "~bulma/sass/utilities/initial-variables";
    @import "~bulma/sass/utilities/derived-variables";
    @import "~bulma/sass/utilities/mixins";

    .message-list {
        position: fixed;
        bottom: 1rem;
        left: 1rem;
        width: 20rem;
    }

    @include mobile {
        .message-list {
            width: calc(100% - 2rem);
        }
    }
</style>